<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProductoAutoresponderLista"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductAutorespondersListsModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <AtomSelectPrimary
          v-model.number="productoAutoresponderLista.academia_autoresponder"
          :elements="academiaAutoresponders"
          :inputError="$v.productoAutoresponderLista.academia_autoresponder.$error"
          keyField="id_academia_autoresponder"
          :label="$t('mEditionProductAutorespondersListsModalCreate.inputs.academia_autoresponder.label')"
          :messageError="messageErrorAcademiaAutoresponder"
          name="autoresponder"
          textField="descripcion"
          @blur="$v.productoAutoresponderLista.academia_autoresponder.$touch()"
        />
        <AtomSelectPrimary
          v-show="academiaAutoresponderListas.length && !showAutoresponderListasNotCreated && !loadingLists"
          v-model="productoAutoresponderLista.lista"
          :elements="academiaAutoresponderListas"
          :inputError="$v.productoAutoresponderLista.lista.$error"
          keyField="id"
          :label="$t('mEditionProductAutorespondersListsModalCreate.inputs.lista.label')"
          :messageError="messageErrorLista"
          name="lista"
          textField="nombre"
          @blur="$v.productoAutoresponderLista.lista.$touch()"
        />
        <AtomLoadingSecondary v-if="loadingLists"/>
        <small
          v-if="showAutoresponderListasNotCreated"
          class="text-color-danger"
        >
          {{ messageErrorAutoresponderLists }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductAutorespondersListsModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductAutorespondersListsModalCreate',

  data () {
    return {
      academiaAutoresponders: [],
      academiaAutoresponderListas: [],
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionProductAutorespondersListsModalCreate.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      loadingLists: false,
      messageErrorAutoresponderLists: '',

      productoAutoresponderLista: {
        academia_autoresponder: 0,
        lista: '',
        nombre_lista: ''
      },

      showAutoresponderListas: false,
      showAutoresponderListasNotCreated: false,
      showLoadingState: true
    }
  },

  validations: {
    productoAutoresponderLista: {
      academia_autoresponder: {
        required
      },

      lista: {
        required
      }
    }
  },

  computed: {
    messageErrorAcademiaAutoresponder () {
      return this.$validation.getValidationMessage('mEditionProductAutorespondersListsModalCreate', this.$v.productoAutoresponderLista.academia_autoresponder, 'academia_autoresponder')
    },

    messageErrorLista () {
      return this.$validation.getValidationMessage('mEditionProductAutorespondersListsModalCreate', this.$v.productoAutoresponderLista.lista, 'lista')
    }
  },

  watch: {
    'productoAutoresponderLista.academia_autoresponder' () {
      this.readAcademiaAutoresponderListas()
    },

    'productoAutoresponderLista.lista' () {
      this.productoAutoresponderLista.nombre_lista = this.academiaAutoresponderListas.find(lista =>
        lista.id === this.productoAutoresponderLista.lista).nombre
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readAcademiaAutoresponders()
  },

  methods: {
    createProductoAutoresponderLista () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoAutoresponderListas', this.productoAutoresponderLista, [this.$route.params.id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductAutorespondersListsModalCreate', 'createProductoAutoresponderLista', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductAutorespondersListsModalCreate', 'createProductoAutoresponderLista', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readAcademiaAutoresponders () {
      this.$services.read('academia', 'readAcademiaAutoresponders', {}, [this.academiaId])
        .then(response => {
          this.academiaAutoresponders = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    readAcademiaAutoresponderListas () {
      this.showAutoresponderListasNotCreated = false
      this.showAutoresponderListas = false
      this.loadingLists = true
      this.$services.read('academia', 'readAcademiaAutoresponderListas', {}, [this.academiaId, this.productoAutoresponderLista.academia_autoresponder])
        .then(response => {
          this.academiaAutoresponderListas = response.data
          this.showAutoresponderListas = true
          this.loadingLists = false
          if (!this.academiaAutoresponderListas.length) {
            this.messageErrorAutoresponderLists = this.$t('mEditionProductAutorespondersListsModalCreate.errorMessages.emptyLists')
            this.showAutoresponderListasNotCreated = true
          } else {
            this.showAutoresponderListasNotCreated = false
          }
        })
        .catch(error => {
          console.log(error)
          this.loadingLists = false
          this.messageErrorAutoresponderLists = this.$t('mEditionProductAutorespondersListsModalCreate.errorMessages.invalidAutoresponder')
          this.showAutoresponderListasNotCreated = true
        })
    }
  }
}
</script>
